import React from "react";

import { Link } from "react-router-dom";
import { useFormContext } from "react-hook-form";

import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";

const DefaultForgotPassword: React.FC<ForgotPasswordProps> = ({
  onSubmit,
  loading,
  t,
}) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <div
      className="vh-100 d-flex align-items-center"
      style={{ background: "white" }}
    >
      <Container>
        <Row className="justify-content-center">
          <Col md={6}>
            <div className="text-center mb-4">
              <h3>{t("forgotPassword:title")}</h3>
              <p className="text-muted">{t("forgotPassword:subtitle")}</p>
            </div>

            <Form onSubmit={onSubmit}>
              <Form.Group className="mb-4">
                <Form.Label>{t("forgotPassword:form.email.label")}</Form.Label>
                <Form.Control
                  type="email"
                  placeholder={t("forgotPassword:form.email.placeholder")}
                  autoComplete="off"
                  isInvalid={!!errors.email}
                  {...register("email")}
                />
                <Form.Control.Feedback type="invalid">
                  {typeof errors.email?.message === "string"
                    ? errors.email.message
                    : null}
                </Form.Control.Feedback>
              </Form.Group>

              <div className="d-flex justify-content-between">
                <Button variant="primary" type="submit" disabled={loading}>
                  {loading ? "Sending..." : t("forgotPassword:button.submit")}
                </Button>
                <Button variant="secondary" as={Link} to="/login">
                  {t("common:backToLogin")}
                </Button>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default DefaultForgotPassword;
